const theme = {
  colors: {
    darkGrey: '#333f58',
    mediumGrey: '#2d3952',
    grey: '#4c5772',
    lightGrey: '#606a86',

    slate: '#8892b0',
    lightSlate: '#a8b2d1',
    lightestSlate: '#ccd6f6',

    offWhite: '#dce7ff',
    white: '#e6f1ff',
    black: '#000',

    pink: '#FF647F',
    yellow: '#E8B863',
    orange: '#FF9E64',

    blue: 'rgb(232, 184, 99)',
    transBlue: 'rgb(232, 184, 99, 0.2)',
    lightTransBlue: 'rgb(232, 184, 99, 0.5)',
    lightblue: '#E7B863',
    highlight: 'rgb(232, 184, 99, 0.5)',

    lightNavy: '#172a45',
    darkNavy: '#020c1b',
    shadowNavy: 'rgba(2, 12, 27, 0.7)',
    transNavy: 'rgba(10, 25, 47, 0.7)',
  },
  fonts: {
    Calibre:
      'Calibre, San Francisco, SF Pro Text, -apple-system, system-ui, BlinkMacSystemFont, Roboto, Helvetica Neue, Segoe UI, Arial, sans-serif',
    SFMono: 'SF Mono, Fira Code, Fira Mono, Roboto Mono, Lucida Console, Monaco, monospace',
  },
  fontSizes: {
    xs: '12px',
    smish: '13px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    xxl: '22px',
    h3: '32px',
  },
  easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  transition: 'all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1)',
  borderRadius: '3px',
  navHeight: '70px',
  navScrollHeight: '70px',
  margin: '20px',
  tabHeight: 42,
  tabWidth: 120,
  radius: 3,
  hamburgerWidth: 30,
  hamBefore: `top 0.1s ease-in 0.25s, opacity 0.1s ease-in`,
  hamBeforeActive: `top 0.1s ease-out, opacity 0.1s ease-out 0.12s`,
  hamAfter: `bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19)`,
  hamAfterActive: `bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s`,
  navDelay: 1000,
  loaderDelay: 2000,
};

export default theme;
